import { Microsoft } from '@mui/icons-material'
import { Button, Box } from '@mui/material'
import { MPH_CONFIG } from 'config'
import { THEMES } from '../../../constants'
import useSettings from 'hooks/useSettings'
import { authClientWithTenant, signInWithMicrosoftTenant } from 'lib/firebase'
import { useMemo, useState } from 'react'

const LoginMPH = () => {
	const { settings } = useSettings()
	const isDark = useMemo(() => settings?.theme === THEMES.DARK, [settings?.theme])
	const imgSrc = useMemo(() => {
		return isDark ? '/static/mph-logo-dark.webp' : '/static/mph-logo-light.webp'
	}, [isDark])

	const [isSubmitting, setIsSubmitting] = useState(false)

	const handleSubmit = async () => {
		setIsSubmitting(true)
		console.log('Attempting to sign in with Microsoft...')
		try {
			const tenantId = MPH_CONFIG.firebaseTenantId
			const MPHMicrosoftTenant = MPH_CONFIG.microsoftTenantId
			const auth = authClientWithTenant(tenantId)
			const signInResult = await signInWithMicrosoftTenant(auth, MPHMicrosoftTenant)

			console.log('Sign-in result:', signInResult)
		} catch (err) {
			console.error('Error signing in with Microsoft:', err)
		} finally {
			setIsSubmitting(false)
		}
	}

	return (
		<div>
			<Box mb={3}>
				<img
					src={imgSrc}
					alt="MPH Logo"
					style={{ width: '150px', display: 'block', margin: '0 auto' }}
				/>
			</Box>
			<Button
				color="primary"
				disabled={isSubmitting}
				loading={isSubmitting}
				fullWidth
				size="large"
				type="submit"
				variant="contained"
				onClick={handleSubmit}
				endIcon={<Microsoft />}
			>
				Sign in with Microsoft
			</Button>
		</div>
	)
}

export default LoginMPH
